import http from './http';

export function fetchApiKeys(params) {
  return http.get('/keys', {
    params
  });
}

export function fetchKeyGroupOptions() {
  return http.get('/keys/group-options');
}

export function fetchAvailableKeyGroupOptions() {
  return http.get('/keys/available-group-options');
}

export function fetchSupportedModels() {
  return http.get('/keys/models');
}

export function fetchPublicSupportedModels() {
  return http.get('/keys/public-models');
}

export function fetchCcSwitchConfig() {
  return http.get('/keys/cc-switch-config');
}

export function createApiKey(keyName, balanceId) {
  return http.post('/keys', {
    keyName,
    balanceId
  });
}

export function updateApiKey(id, keyName, balanceId) {
  return http.put(`/keys/${id}`, {
    keyName,
    balanceId
  });
}

export function deleteApiKey(id) {
  return http.delete(`/keys/${id}`);
}
